import Axios from 'axios';

import wxHelper from "wechat-helper";

const axios = Axios.create();
wxHelper.init({
  onSuccess:()=>{

  },
  onFail:()=>{

  },
  // hideMenuList:[],
  apis:[
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareAppMessage',
    'onMenuShareTimeline',
    'hideOptionMenu',
    'hideMenuItems',
    'onMenuShareWeibo',
    'onMenuShareQZone'
  ],
  apiSign:async (url)=>{
    let req = await axios.get('https://wishing-api.kingnet.com/wechat_jssdk_config', {
      params: {
        url,
      }
    });
    console.log(req);
    if(req?.data?.code==0){
      const {appId,timestamp,nonceStr,signature} = req.data.data;
      return {
        appId,
        timestamp,
        nonceStr,
        signature
      };
    }
  },
  apiGetUserInfo:async (code)=>{
    let req = await axios.get('/yourApi', {
      params: {
        code,
        appId:'yourAppId'
      }
    });
    console.log(req);
  },
  debug:false
})

// 分享
wxHelper.setShare({
  title:'「恺心公益」邀请您参与“心愿树”活动，为高原孩子实现心愿',
  desc:'',
  imgUrl:`https://wishing.kingnet.com/static/share001.png`,
  link:location.href,
  success:()=>{
    console.log('分享内容设置成功')
    // alert('分享内容设置成功');
  }
}); 

let authInfo= wxHelper.getAuth(false);
authInfo;
export default wxHelper;